module.exports = __webpack_public_path__ + "media/images/article/sum01-f18510f721078f3d1efa148a1fa53ced.png";